export default {
	name: "view-submission-modal",
	props: ["heading", "modalId", "showModal", "campaignSubmission", "submissionIsDrawnWinner"],
	emits: ["okClicked", "drawnWinnerRejectedRedraw"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			submission: {},
			loading: false,
			showErrorMessage: false,
			winnerSaveMessage: null,
			winnerRejected: false
		};
	},
	methods: {
		onModalCloseClick(){
			this.$emit("okClicked");
		},
		addOrUpdateCampaignWinner(isApproved){
			this.loading = true;
			this.winnerRejected = false;
			let request = {
				campaignId: this.submission.campaignId,
				submissionId: this.submission.submissionId,
				isApproved: isApproved
			};
			competitionService.addOrUpdateCampaignWinner(request).then(
				response => {
					if(response.status === 200){
						if(isApproved){
							this.winnerSaveMessage = "Winner has been approved";
						}
						else{
							this.winnerSaveMessage = "Winner has been rejected. Draw new winner?";
							this.winnerRejected = true;
						}
					}
					this.loading = false;
				}
			);
		},
		redrawWinner(){
			this.showErrorMessage = false;
			this.winnerSaveMessage = null;
			this.winnerRejected = false;
			this.$emit("drawnWinnerRejectedRedraw");
		},
		downloadSubmissionTillSlip() {
			this.loading = true;
			let request = {
				tillSlip: this.submission.fileUpload
			};
			competitionService.downloadSubmissionTillSlip(request).then(
				response => {
					if (response.status === 200) {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.submission.fileName);
						document.body.appendChild(link);
						link.click();
					}
					this.loading = false;
				}
			);
		}
	},
	mounted: function () {
		
	},
	watch:{
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				console.log("showModal", this.showModal);
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		campaignSubmission: {
			handler: function (){
				if(this.campaignSubmission !== null && this.campaignSubmission !== undefined){
					this.submission = this.campaignSubmission;
					this.submission = dataTableHelper.castObjectValues(this.submission);
				}
			}
		}
	}
};